export default "__VITE_ASSET__q7gd6Ms$__"